import React from 'react';
import './SlotSelection.css';

export interface AvailableSlot {
  slot_code: string;
  slot_name: string;
  start_time: string;
  end_time: string;
  discount_type: string;
  base_price: number;
  discount_percentage: number;
  discount_amount: number;
  final_price: number;
  used_count: number;
  meals_limit: number;
}

interface SlotSelectionProps {
  availableSlots: AvailableSlot[];
  customerName: string | null;
  onSelectSlot: (slot: AvailableSlot) => void;
  onCancel: () => void;
}

const SlotSelection: React.FC<SlotSelectionProps> = ({
  availableSlots,
  customerName,
  onSelectSlot,
  onCancel
}) => {
  const logout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('authToken');
    window.location.reload();
  };

  return (
    <div className="slot-selection-container">
      <div className="slot-selection-header">
        <h1>Seleziona Pasto</h1>
        <button className="logout-btn" onClick={logout}>
          Logout
        </button>
      </div>

      <div className="slot-selection-card">
        {customerName && (
          <div className="customer-name">
            <span className="customer-label">Cliente:</span>
            <span className="customer-value">{customerName}</span>
          </div>
        )}

        <h2>Quale pasto vuoi erogare?</h2>

        <div className="slot-buttons-grid">
          {availableSlots.map((slot, index) => (
            <button
              key={index}
              className="slot-button"
              onClick={() => onSelectSlot(slot)}
            >
              <div className="slot-button-name">{slot.slot_name}</div>
            </button>
          ))}
        </div>

        <button className="cancel-button" onClick={onCancel}>
          Annulla
        </button>
      </div>
    </div>
  );
};

export default SlotSelection;
